import React from "react";
import { ThreeEvent } from "@react-three/fiber";
import * as THREE from "three";
import { SymbolType, VoidType } from "../../../../../types/floorplannerTypes";
import ExtrudedShapeMesh from "../../../scene/ExtrudedShapeMesh";
import { usePointerUpSelection } from "../../../scene/usePointerUpSelection";
import { getSymbol3DBaseElevation } from "../openingGeometry";

const VoidOpening3D: React.FC<{
  symbol: VoidType;
  selected: boolean;
  shape: THREE.Shape;
  wallHeight: number;
  claimSelectionEvents?: boolean;
  onSelectSymbol: (symbol: SymbolType, event: ThreeEvent<PointerEvent>) => void;
}> = ({
  symbol,
  selected,
  shape,
  wallHeight,
  claimSelectionEvents = false,
  onSelectSymbol,
}) => {
  const selectionHandlers = usePointerUpSelection(symbol, onSelectSymbol, {
    claimPointerEvents: claimSelectionEvents,
  });
  const baseElevation = THREE.MathUtils.clamp(
    getSymbol3DBaseElevation(symbol),
    0,
    wallHeight,
  );
  const height = Math.max(
    Math.min(
      symbol.threeD?.height ?? wallHeight - baseElevation,
      wallHeight - baseElevation,
    ),
    0.001,
  );

  return (
    <ExtrudedShapeMesh
      shape={shape}
      depth={height}
      positionZ={baseElevation}
      castShadow={false}
      receiveShadow={false}
      selected={selected}
      {...selectionHandlers}
      userData={{
        floorplannerType: symbol.type,
        floorplannerId: symbol.id,
      }}
    >
      <meshBasicMaterial
        color={0xffffff}
        transparent
        opacity={0}
        depthWrite={false}
      />
    </ExtrudedShapeMesh>
  );
};

export default VoidOpening3D;
